import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import AccordionItem from './AccordionItem';
import ProducerNotes from '../../objects/producerNotes/ProducerNotes';
import NotReadyYet from '../../objects/producerNotes/NotReadyYet';
import Button from '../../buttons/Button';//eslint-disable-line import/no-named-as-default
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as appDataActions from '../../../actions/appDataActions';
import * as userDataActions from '../../../actions/userDataActions';
import * as appHelper from '../../../helpers/appHelper';
import * as dataHelper from '../../../helpers/dataHelper';
import * as appConstants from '../../../constants/appConstants';
import * as objectConstants from '../../../constants/objectConstants';
import * as assetConstants from '../../../constants/assetConstants';
import * as localStorage from '../../../localStorage/localStorage';
import * as userDataHelper from '../../../helpers/userDataHelper';

import {getScreenComponentByType} from '../../../helpers/componentHelper';
import {TweenLite, Elastic, Bounce, Expo} from 'gsap';
import gsap from 'gsap-react-plugin';
import _ from 'lodash';

class AccordionScreen extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            screen: this.props.screen,
            userData: this.props.userData,
            locale: appHelper.getLocalData(this.props.screen),
            status: userDataHelper.getScreenUserData(this.props.userData, this.props.screen.screen_id).status,// objectConstants.STATUS_IN_PROGRESS,
            callbacks: {},
            assets: {
                background: {
                    src: "",

                },
                hotspotBackground: {
                    src: "",
                }
            },
            activeScreen: {
                screen_id: 0
            },
            renderedScreen: {},
            enabledScreens: [],
            completeScreens: [],
            toggleAllItems: false,
            isAnimating: false,
            producerNotes: appHelper.getScreenNotes(undefined,this.props.screen),
            screenIsReady: this.props.screen.sub_screens.length > 0 && appHelper.canSeeContent(this.props.screen),
            allowClippedBlurEffect: appHelper.allowClippedBlurEffect(),
            isOpenNavigation: appHelper.getBiteById(this.props.biteCallbacks.getBiteId()).navigation_type === objectConstants.PROGRESSION_TYPE_OPEN,
            continue_label: appHelper.getLocaleString("continue_label")
        };
        this.getScreenId = this.getScreenId.bind(this);
        this.getBiteId = this.getBiteId.bind(this);
        this.getAssets = this.getAssets.bind(this);
        this.getImagePath = this.getImagePath.bind(this);
        this.checkScreenStatus = this.checkScreenStatus.bind(this);
        this.setCallbacks = this.setCallbacks.bind(this);
        this.setEnabledTabs = this.setEnabledTabs.bind(this);
        this.setTabActive = this.setTabActive.bind(this);
        this.setRenderedScreen = this.setRenderedScreen.bind(this);
        this.onSubScreenComplete = this.onSubScreenComplete.bind(this);
        this.goToNextSubScreen = this.goToNextSubScreen.bind(this);
        this.hasNextSubScreen = this.hasNextSubScreen.bind(this);
        this.checkScreenComplete = this.checkScreenComplete.bind(this);
        this.updateScreenResults = _.debounce(this.updateScreenResults.bind(this), 300);
        this.setScreenAccessed = _.debounce(this.setScreenAccessed.bind(this), 300);
        this.navigateToNextScreen = this.navigateToNextScreen.bind(this);
        this.toggleAccordion = this.toggleAccordion.bind(this);
        this.onItemsClosed = this.onItemsClosed.bind(this);
        this.setIsAnimating = this.setIsAnimating.bind(this);
        this.scrollTo = this.scrollTo.bind(this);
        this.completeScreen = this.completeScreen.bind(this);
        this.setScreenNotReadyYet = this.setScreenNotReadyYet.bind(this);
        this.getCanScrollScreenClass = this.getCanScrollScreenClass.bind(this);
        this.getPanelStyle = this.getPanelStyle.bind(this);
        this.getFeedClass = this.getFeedClass.bind(this);
    }



    componentDidMount() {
        this.setScreenAccessed();
        this.props.biteCallbacks.showHeader(true);
        this.props.actions.setScreenTitle(this.state.locale.title);
        this.getAssets();
        this.setCallbacks();

        if(this.state.screenIsReady){
            this.setEnabledTabs();
            this.checkScreenStatus();
        }else{
            this.setScreenNotReadyYet();
        }

    }

    componentWillReceiveProps(nextProps) {
        let screenUserData = userDataHelper.getScreenUserData(nextProps.userData, this.state.screen.screen_id);
        if(screenUserData.status === objectConstants.STATUS_COMPLETE){
            this.setState({
                status: screenUserData.status,
                enabledScreens: screenUserData.status === objectConstants.STATUS_COMPLETE ? this.state.screen.sub_screens : this.state.enabledScreens,
                completeScreens: screenUserData.status === objectConstants.STATUS_COMPLETE ? this.state.screen.sub_screens : this.state.completedScreens
            });
        }else if(this.state.isOpenNavigation){
            this.setState({
                enabledScreens: Object.assign([], this.state.screen.sub_screens)
            });
        }
        this.setState({userData: Object.assign({}, nextProps.userData)});

        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.screen),
                continue_label: appHelper.getLocaleString("continue_label")
            });
            this.props.actions.setScreenTitle(appHelper.getLocalData(this.state.screen).title);
        }
    }

    componentDidUpdate() {
        if (typeof this.state.renderedScreen.data === "undefined" && typeof this.state.activeScreen.screen_id !== "undefined") {
            this.setRenderedScreen();

        }

    }

    setScreenAccessed(){
        this.props.actions.setScreenAccessed(this.state.screen);
    }

    setScreenNotReadyYet(){
        this.setState({status: objectConstants.STATUS_COMPLETE});
        this.updateScreenResults(objectConstants.STATUS_COMPLETE);
    }

    checkScreenStatus() {
        let screenUserData = userDataHelper.getScreenUserData(this.state.userData, this.state.screen.screen_id);
        if(screenUserData.status === objectConstants.STATUS_COMPLETE){
            this.setState({
                status: screenUserData.status,
                enabledScreens: screenUserData.status === objectConstants.STATUS_COMPLETE ? this.state.screen.sub_screens : this.state.enabledScreens,
                completeScreens: screenUserData.status === objectConstants.STATUS_COMPLETE ? this.state.screen.sub_screens : this.state.completedScreens
            });
        }else if(this.state.isOpenNavigation){
            this.setState({
                enabledScreens: Object.assign([], this.state.screen.sub_screens)
            });
        }
    }

    getAssets() {
        let background = {};
        let hotspotBackground = {};

        if (appHelper.isDefined(this.state.screen.assets.background)) {
            background = appHelper.getBackgroundAsset(this.state.screen.assets.background);
        }
        if (appHelper.isDefined(this.state.screen.assets.hotspot)) {
            hotspotBackground = appHelper.getHotspotBackgroundAsset(this.state.screen.assets.hotspot);
        }
        this.setState({
            assets: Object.assign({}, this.state.assets, {
                background: appHelper.isDefined(background.src) ? background : this.state.assets.background,
                hotspotBackground: appHelper.isDefined(hotspotBackground.src) ? hotspotBackground : this.state.assets.hotspotBackground

            })
        });
        if(this.state.screen.sub_screens.length > 0) {
            if (!appHelper.isDefined(hotspotBackground.src) || (appHelper.isDefined(hotspotBackground.src) && hotspotBackground.src.length === 0)) {
                this.setTabActive(this.state.screen.sub_screens[0]);
                this.toggleAccordion(this.state.screen.sub_screens[0]);
            }
        }
    }

    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }

    setCallbacks() {
        this.setState({
            callbacks: Object.assign({}, this.props.biteCallbacks, {
                //onObjectComplete: this.onObjectComplete,
                getScreenId: this.getScreenId,
                getBiteId: this.getBiteId,
                onSubScreenComplete: this.onSubScreenComplete,
                goToNextSubScreen: this.goToNextSubScreen,
                hasNextSubScreen: this.hasNextSubScreen,
                toggleAccordion: this.toggleAccordion,
                onItemsClosed: this.onItemsClosed,
                setIsAnimating: this.setIsAnimating,
                scrollTo: this.scrollTo,
                completeScreen: this.completeScreen,
                //objectIsEnabled: this.objectIsEnabled,
                //objectIsComplete: this.objectIsComplete,
                //storeUserResponse: this.storeUserResponse,
                //scrollTo: this.scrollTo,
                //isReviewMode: this.isReviewMode
            })
        });
    }

    scrollTo(pos) {
        let feed = this.refs[`${this.state.screen.screen_id}_feed`];
        TweenLite.to(feed, objectConstants.SHOW_PANEL_DURATION, {
            scrollTop: pos,
            ease: Expo.easeInOut,
        }).eventCallback("onComplete", this.onScrollComplete);
    }

    getScreenId() {
        return this.state.screen.screen_id;
    }

    getBiteId() {
        //console.log(`getBiteId`);
        return this.props.biteCallbacks.getBiteId();
    }

    setEnabledTabs() {
        if (this.state.status !== objectConstants.STATUS_COMPLETE) {
            //if (this.state.screen.progression === objectConstants.OBJECT_PROGRESSION_LINEAR) {
            if(this.state.isOpenNavigation) {
                this.setState({
                    enabledScreens: Object.assign([], this.state.screen.sub_screens)
                });
            }else {
                this.setState({enabledScreens: dataHelper.immutablePush(this.state.enabledScreens, this.state.screen.sub_screens[0])});
            }
            //} else {
            //    this.setState({enabledObjects: Object.assign([], this.state.screen.objects)});
            // }

        } else {
            //  console.log("hello");
            this.setState(
                {
                    enabledObjects: Object.assign([], this.state.screen.objects),
                    completeObjects: Object.assign([], this.state.screen.objects),
                    checkContinueBtnState: true,
                    propsUpdated: false
                }
            );
        }
    }

    setTabActive(screen) {
        //set renderedObject to empty so that when component updates we make sure we can set it again and we get exactly what we want rendered
        this.setState({activeScreen: screen, renderedScreen: {}});
        //this.setBackButtonDisplayState(object);
        //this.setContinueButtonDisplayState(object);
    }

    setRenderedScreen() {
        let screenType = Object.assign({}, getScreenComponentByType(this.state.activeScreen.screen_type),
            {
                data: this.state.activeScreen
            }
        );

        this.setState({renderedScreen: Object.assign({}, screenType)});
    }



    toggleAccordion(screen) {
        if (appHelper.isDefined(this.state.activeScreen.screen_id)) {
            if (screen.screen_id !== this.state.activeScreen.screen_id) {
                this.setState({activeScreen: Object.assign({}, screen), toggleAllItems: true});
            } else {
                this.setState({activeScreen: Object.assign({}, {
                    screen_id: 0,
                }), toggleAllItems: true});
            }
        } else {
            this.setState({activeScreen: Object.assign({}, screen), toggleAllItems: true});
        }
    }

    setIsAnimating(isAnimating){
        this.setState({isAnimating: isAnimating});
    }

    onItemsClosed(){
        this.setState({toggleAllItems: false});
    }


    onSubScreenComplete(screen) {
        //console.log(screen);
        let completionIndex = appHelper.getArrayObjectIndexByKey(this.state.completeScreens, "screen_id", screen.screen_id);
        let subScreenIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.sub_screens, "screen_id", screen.screen_id);
        let nextScreen = {};

        if (subScreenIndex < (this.state.screen.sub_screens.length - 1)) {
            nextScreen = Object.assign({}, this.state.screen.sub_screens[subScreenIndex + 1]);
        }

        if (completionIndex === -1) {
            this.setState(
                {
                    completeScreens: dataHelper.immutablePush(this.state.completeScreens, screen),
                    enabledScreens: typeof nextScreen.screen_id !== "undefined" ? dataHelper.immutablePush(this.state.enabledScreens, nextScreen) : Object.assign([], this.state.enabledScreens),
                    checkContinueBtnState: true
                }
            );
            // this.updateScreenResults(this.state.status !== objectConstants.STATUS_COMPLETE ? objectConstants.STATUS_IN_PROGRESS: objectConstants.STATUS_COMPLETE, object.object_id);
        }

        this.checkScreenComplete();
    }

    hasNextSubScreen(screen) {
        let subScreenIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.sub_screens, "screen_id", screen.screen_id);
        return subScreenIndex < (this.state.screen.sub_screens.length - 1);
    }

    goToNextSubScreen(screen) {
        let subScreenIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.sub_screens, "screen_id", screen.screen_id);
        if (this.hasNextSubScreen(screen)) {
            let nextScreen = Object.assign({}, this.state.screen.sub_screens[subScreenIndex + 1]);
            this.setTabActive(nextScreen);
            this.toggleAccordion(nextScreen);
        } else {
            this.navigateToNextScreen();
        }
    }

    navigateToNextScreen() {
        if (appHelper.isDefined(this.state.screen.next_screen_id) && !isNaN(this.state.screen.next_screen_id)) {
            this.goToScreen(this.state.screen.next_screen_id);
        } else {
            let nextScreenId = appHelper.getNextScreenId(this.getScreenId());
            if (localStorage.bites.length > 1 && nextScreenId.length === 0) {
                this.context.router.push('menu');
            } else {
                this.props.actions.setNextLessonLocation(this.getScreenId());
            }
        }
    }

    checkScreenComplete() {
        if (this.state.completeScreens.length >= this.state.screen.sub_screens.length) {
            this.setState(
                {
                    status: objectConstants.STATUS_COMPLETE
                }
            );
            this.updateScreenResults(objectConstants.STATUS_COMPLETE);
        }
    }

    //used when child screen terminates
    completeScreen(){
        this.setState(
            {
                status: objectConstants.STATUS_COMPLETE
            }
        );
        this.updateScreenResults(objectConstants.STATUS_COMPLETE);
    }

    updateScreenResults(screen_status) {
        let params = {
            bite_id: this.getBiteId(),
            screen_id: this.getScreenId(),
            screen_status: screen_status,
            object_status: objectConstants.STATUS_COMPLETE,
        };

        this.props.actions.updateScreenResults(params).then((userData) => {
            this.props.actions.setSuspendData(userData).then((trackingData) => {
                if(screen_status === objectConstants.STATUS_COMPLETE){
                    this.props.actions.setScreenComplete(this.state.screen);
                }
            }).catch(error => {
            });
        }).catch(error => {
        });
    }

    getCanScrollScreenClass(){
        return  parseFloat(this.state.activeScreen.screen_id) === 0 ? "allow-scroll" : "";
        //return "allow-scroll";
    }

    getPanelStyle() {
        return appHelper.isDefined(this.state.screen.panel_style) ? this.state.screen.panel_style : "frosted_white";

    }

    getFeedClass() {
        return this.state.allowClippedBlurEffect ? 'blurred-feed' : 'standard-feed';
    }

    render() {
        let renderedScreen = this.state.renderedScreen;
        return (
            <div className="customer-scenario">
                <div className="background-container">
                    <img src={this.getImagePath(this.state.assets.background.src)} alt=""/>
                </div>
                <div className="screen-container">
                    <div className={`accordion-screen ${this.getPanelStyle()}`}>
                        {
                            this.state.allowClippedBlurEffect
                                ?
                                <div className={`content-wrapper-background `}>
                                    <img className="blur" src={this.getImagePath(this.state.assets.background.src)} alt=""/>
                                </div>
                                :
                                null
                        }
                        <div className={`accordion-content-wrapper ${this.getFeedClass()}  ${this.getCanScrollScreenClass()}`} ref={`${this.state.screen.screen_id}_feed`}>
                            {
                                appHelper.isDefined(this.state.assets.hotspotBackground.src) && this.state.assets.hotspotBackground.src.length > 0 && this.state.screen.sub_screens.length > 0
                                    ?
                                    <div className="background-image">
                                        <img className={`hot-spot-background`}
                                             src={this.getImagePath(this.state.assets.hotspotBackground.src)} alt=""/>
                                    </div>
                                    :
                                    null
                            }



                            <div className="accordion">
                                {this.state.screen.sub_screens.map(sub_screen =>
                                    typeof this.state.activeScreen.screen_id !== "undefined" && this.state.screenIsReady
                                        ?
                                        <AccordionItem key={`${sub_screen.screen_id}_tab`}
                                                       parentScreen={this.state.screen}
                                                       screen={sub_screen}
                                                       activeScreenId={parseInt(this.state.activeScreen.screen_id)}
                                                       enabledScreens={this.state.enabledScreens}
                                                       completeScreens={this.state.completeScreens}
                                                       toggleAllItems={this.state.toggleAllItems}
                                                       isAnimating={this.state.isAnimating}
                                                       biteCallbacks={this.state.callbacks}/>
                                        : null
                                )}
                                {
                                    !this.state.screenIsReady
                                        ?
                                        <div>
                                            {this.state.producerNotes.length > 0
                                                ?
                                                <ProducerNotes notes={this.state.producerNotes}
                                                               screen_id={this.state.screen.screen_id}/>
                                                :
                                                null
                                            }
                                            <NotReadyYet screen_id={this.state.screen.screen_id} />
                                            <Button ref={`${this.state.screen.screen_id}_button`}
                                                    label={this.state.continue_label}
                                                    id={`${this.state.screen.screen_id}_button`}
                                                    onClick={this.navigateToNextScreen}
                                                    onRevealed={this.onContinueBtnReveled} />
                                        </div>
                                        :
                                        null
                                }
                            </div>


                        </div>
                    </div>
                </div>

            </div>
        );
    }
}

/*
* <div className="tabbed-body-content" ref={`${this.state.screen.screen_id}_feed`}>
                            {typeof renderedScreen.data !== "undefined"
                                ?
                                <renderedScreen.component screen={renderedScreen.data} parentScreen={this.state.screen}
                                                          biteCallbacks={this.state.callbacks}/>
                                : null
                            }
                        </div>
* */

AccordionScreen.propTypes = {
    screen: PropTypes.object.isRequired,
    biteCallbacks: PropTypes.object.isRequired,
    titles: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired,
    userData: PropTypes.object.isRequired,
};

AccordionScreen.contextTypes = {
    router: PropTypes.object,

};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,
        titles: state.titles,
        userData: state.userData,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, appDataActions, trackingDataActions, userDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(AccordionScreen);



/** WEBPACK FOOTER **
 ** ./src/components/screens/accordionScreen/AccordionScreen.js
 **/